import React from 'react';
import {updateIncome} from '../../../redux/app-state-slice';
import {currencyFormat} from '../../../utils/functions/Functions';
import Input from '../../../components/Input/Input';

function GrossYearlyIncome({dispatch, income, className, ...restProps}) {
  return (
    <Input
      onInputChangeHandler={(e) => dispatch(updateIncome(e.target.value))}
      onBlurChangeHandler={(e) => dispatch(updateIncome(e.target.value.trim()))}
      slot='input'
      dataTestId='income'
      name='grossAnnualIncome'
      placeholder='Gross Yearly Income'
      className={className}
      pattern='[0-9]*'
      inputMode='numeric'
      value={income.value ? currencyFormat(income.value) : ''}
      inputHasError={income.errorMessage}
      {...restProps}
    />
  );
}

export default GrossYearlyIncome;
